import { gql } from "@apollo/client"
import { LoadingSpinner } from "@oysterhr/ui"
import { useQuery } from "@oysterhr/core"
import { Company } from "@oysterhr/schema"
import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import { companyNewHirePath } from "@oysterhr/router"
import { CostCalculatorPageLayout } from "../components/CostCalculatorPageLayout"
import { useEffect } from "react"
import { useRecordCostCalculatorVisit } from "@oysterhr/monetization"
const CompanyCurrencyQuery = gql`
  query CompanyCurrency($companyId: ID!) {
    company(companyId: $companyId) {
      id
      paymentCurrencyCode
      visitedCostCalculator
    }
  }
`

export function CostCalculatorCompanyPage() {
  // We can use the useAccountAspect hook here since this page is used inside our platform
  const { accountAspect } = useAccountAspect()

  const companyStrongId = accountAspect.split("Company:")[1]

  const { loading, data } = useQuery<{ company: Company }, { companyId: string }>(
    CompanyCurrencyQuery,
    { variables: { companyId: accountAspect } },
  )

  const [recordVisit] = useRecordCostCalculatorVisit()

  useEffect(() => {
    if (!loading && data) {
      const visitedCostCalculator = data?.company.visitedCostCalculator

      if (!visitedCostCalculator) {
        recordVisit({
          variables: { input: { companyId: accountAspect } },
        })
      }
    }
  }, [loading, data, accountAspect, recordVisit])

  if (loading) {
    return <LoadingSpinner size="md" />
  }

  const hireUrl = companyNewHirePath(companyStrongId)

  return (
    <CostCalculatorPageLayout
      hireUrl={hireUrl}
      eventPrefix="CA"
      companyCurrencyCode={data?.company.paymentCurrencyCode ?? undefined}
    />
  )
}
